export class SearchCriteria {
  constructor() {
    /**
     * Backend does not accept 'undefined'.
     * Hence initialize to empty string. */

    this.productRadio = "dbs"; // default dbs
    this.policyNo = "";
    this.invoiceNo = "";
    this.chequeNo = "";
    this.cin = "";
    this.segments = [];
    this.productIds = [];
    this.statusIds = [];
    this.autoDebitPeriodYear = "";
    this.autoDebitPeriodMonth = "";
    this.autoDebitPeriodDate = "";
  }

  pageNo!: number;
  pageSize!: number;

  productRadio: string;
  policyNo: string;
  invoiceNo: string;
  chequeNo: string;
  cin: string;
  segments: Array<string>;
  effectiveDateFrom?: Date;
  effectiveDateTo?: Date;
  autoDebitPeriod: any;
  autoDebitPeriodYear: string;
  autoDebitPeriodMonth: string;
  autoDebitPeriodDate: string;
  productIds: Array<string>;
  statusIds: Array<string>;
  policyeffectiveDateFrom?: Date;
  policyeffectiveDateTo?: Date;
}
export class BatchInvoiceEntity {
  id!: string;
  statusId!: number;
  policyNo!: string;
  invoiceNo!: string;
  amount!: string;
  amountGst!: string;
  stampDuty!: string;
  payerTypeId!: number;
  autoDebitTransId!: number;
  invoiceId!: number;
  refundId!: number;
  manualPaymentId!: number;
  dateCreated!: string;
  createdByUserName!: string;
  lastUpdatedByUserName!: string;
  batchId!: number;
  policyCertificateNumber!: string;
  startEffectiveDate!: string;
  autoDebitMonth!: number;
  manualPaymentChequeNumber!: string;
  manualPaymentChequeIssuanceBank!: string;
  refundPaymentChequeNumber!: string;
  refundPaymentChequeIssuanceBank!: string;
  remarks!: string;
  payerName!: string;
  manualPaymentRemarks!: string;
  refundPaymentRemarks!: string;
  statusDisplayText!: string;
  autoDebitMonthDisplayText!: string;
  chequeIssuanceBank!: string;
  chequeNumber!: string;
}
export class UpdateBatchInvoiceEntity {
  amount!: string;
  amountGst!: string;
  batchId!: number;
  invoiceNo!: number;
  lastUpdatedByUserName!: string;
  openItemId!: string;
  policyCertificateNumber!: string;
  policyNo!: string;
  status!: number;
  statusDisplayText!: string;
}

export class AllPoliciesDownloadEntity {
  amount!: string;
  amountGst!: string;
  batchId!: number;
  invoiceNo!: number;
  lastUpdatedByUserName!: string;
  openItemId!: string;
  policyCertificateNumber!: string;
  policyNo!: string;
  status!: number;
  statusDisplayText!: string;
}
